(function () {
  function updateVideosArrows(wrap, track) {
    if (!wrap || !track) return;
    var left = track.scrollLeft;
    var maxLeft = track.scrollWidth - track.clientWidth;
    wrap.classList.toggle('at-start', left <= 1);
    wrap.classList.toggle('at-end', maxLeft <= 1 || left >= maxLeft - 1);
  }

  function initScroll() {
    document.querySelectorAll('[data-videos-scroll]').forEach(function (track) {
      var wrap = track.closest('.product-videos-in-action__scroll-wrap');
      if (!wrap) return;
      var prevBtn = wrap.querySelector('.product-videos-in-action__arrow--prev');
      var nextBtn = wrap.querySelector('.product-videos-in-action__arrow--next');
      var step = 120;

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          track.scrollBy({ left: -step, behavior: 'smooth' });
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          track.scrollBy({ left: step, behavior: 'smooth' });
        });
      }

      track.addEventListener('scroll', function () {
        updateVideosArrows(wrap, track);
      });

      if (typeof ResizeObserver !== 'undefined') {
        var ro = new ResizeObserver(function () {
          updateVideosArrows(wrap, track);
        });
        ro.observe(track);
      }

      updateVideosArrows(wrap, track);
    });
  }

  function init() {
    initScroll();

    document.querySelectorAll('.product-videos-in-action').forEach(function (wrapper) {
      wrapper.querySelectorAll('.product-videos-in-action__card[data-video-lightbox]').forEach(function (card) {
        var lightboxId = card.getAttribute('data-video-lightbox');
        var lightbox = document.getElementById(lightboxId);
        if (!lightbox) return;

        function openLightbox() {
          if (lightbox.parentNode !== document.body) {
            document.body.appendChild(lightbox);
          }
          lightbox.hidden = false;
          lightbox.classList.add('product-videos-lightbox--open');
          var video = lightbox.querySelector('video');
          if (video) {
            video.muted = true;
            video.currentTime = 0;
            video.play();
          }
          var muteBtn = lightbox.querySelector('[data-mute-btn]');
          if (muteBtn) muteBtn.classList.remove('is-unmuted');
          document.body.style.overflow = 'hidden';
          var closeBtn = lightbox.querySelector('.product-videos-lightbox__close');
          if (closeBtn) closeBtn.focus();
        }

        function closeLightbox() {
          lightbox.hidden = true;
          lightbox.classList.remove('product-videos-lightbox--open');
          var video = lightbox.querySelector('video');
          if (video) {
            video.pause();
            video.muted = true;
          }
          var muteBtn = lightbox.querySelector('[data-mute-btn]');
          if (muteBtn) muteBtn.classList.remove('is-unmuted');
          document.body.style.overflow = '';
        }

        card.addEventListener('click', function () {
          openLightbox();
        });

        var muteBtn = lightbox.querySelector('[data-mute-btn]');
        if (muteBtn) {
          muteBtn.addEventListener('click', function (e) {
            e.stopPropagation();
            var video = lightbox.querySelector('video');
            if (!video) return;
            video.muted = !video.muted;
            muteBtn.classList.toggle('is-unmuted', !video.muted);
          });
        }

        var closeBtn = lightbox.querySelector('.product-videos-lightbox__close');
        var backdrop = lightbox.querySelector('.product-videos-lightbox__backdrop');
        if (closeBtn) closeBtn.addEventListener('click', closeLightbox);
        if (backdrop) backdrop.addEventListener('click', closeLightbox);

        lightbox.addEventListener('click', function (e) {
          var inner = lightbox.querySelector('.product-videos-lightbox__inner');
          if (inner && !inner.contains(e.target) && !e.target.closest('.product-videos-lightbox__close')) {
            closeLightbox();
          }
        });

        lightbox.addEventListener('keydown', function (e) {
          if (e.key === 'Escape') closeLightbox();
        });
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var open = document.querySelector('.product-videos-lightbox--open');
      if (open) {
        open.hidden = true;
        open.classList.remove('product-videos-lightbox--open');
        var video = open.querySelector('video');
        if (video) video.pause();
        document.body.style.overflow = '';
      }
    });
  }

  function run() {
    try {
      init();
    } catch (e) {
      console.error('product-videos-in-action:', e);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
